import { Tables } from '../../component/table'
import { useMemo } from 'react'
import { KTCard } from '../../../_metronic/helpers'
// import { useQueryResponseCount, useQueryResponseLoading } from '../../component/response'
// import { getProjectByLocal } from '../projectData'
import { LuckyDrawWrapper } from './luckyDrawWrapper'

/**
 * CustomerTableHeader
 * Renders the header for the lucky draw table, displays instructions and draw date.
 */
const CustomerTableHeader = () => {
    // const isLoading = useQueryResponseLoading()
    // const count = useQueryResponseCount()
    // const project = getProjectByLocal()

    return <><div style={{ background: '#EBF3FC' }} className='d-flex rounded p-3'>
        <div className="fs-6 fw-semibold">The coupon codes assigned to you are listed below. The results will be displayed once the lucky draw is conducted.</div>
    </div>
        <div className="d-flex align-items-center mt-3">
            <div style={{ background: '#3457A3' }} className='text-center text-white fs-3 fw-semibold rounded p-3 w-100'>Lucky Draw Date : <span className='text-success text-bolder'> 5-Apr-25 (3 PM to 4 PM)</span></div>
        </div>
    </>

}

/**
 * LuckyDrawList
 * Displays the list of assigned coupon codes and lucky draw results.
 */
const LuckyDrawList = () => {


    const columns = useMemo(
        () => [
            {
                Header: (props) => {
                    return <th {...props.column.getHeaderProps()} >
                        <div className="d-flex flex-column">
                            <span className=""> Coupon Code </span>

                        </div>

                    </th>
                },
                id: 'coupon_code',
                Cell: ({ row }) => {
                    return (
                        <>

                            <div className="blue  text-danger text-capitalize">{row.original.coupon_code}</div>

                        </>
                    );
                },
            },


            {
                Header: 'Result',
                accessor: 'Result',
                Cell: ({ row }) => {
                    return (
                        <>
                            <div className="blue text-success text-capitalize"> {row.original.result ? row.original.result : '--'}</div>

                        </>
                    );
                },
            },
            {
                Header: 'Gift Name',
                accessor: 'debit',
                Cell: ({ row }) => {
                    return (
                        <>
                            <div className="blue text-danger">

                                {row.original.gift_name ? row.original.gift_name : '--'}
                            </div>

                        </>
                    );
                },
            },


        ],
        []
    )

    return <LuckyDrawWrapper>
        <div className='container-fluid mt-3'>
            <KTCard>
                <CustomerTableHeader />
                <Tables columns={columns} />
            </KTCard>
        </div>
    </LuckyDrawWrapper>
}



export { LuckyDrawList }